import { Injectable } from '@angular/core';
import { Wine } from '../interfaces/wine';
import {
  AngularFireDatabase,
  AngularFireList,
  AngularFireObject,
} from '@angular/fire/compat/database';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WineCrudService {

  refs: AngularFireList<any> | undefined;
  ref: AngularFireObject<any> | undefined;

  path: string;

  constructor(private db: AngularFireDatabase) {
    this.path = environment.name + '/wines/current/' ;
  }

  // Create Wine
  add(record: Wine) {
    this.refs = this.db.list( this.path );
    const item = {
      ...record
    }
    this.refs?.push( item );
  }
  // Fetch Single Wine Object
  get(id: string) {
    this.ref = this.db.object( this.path + id);
    return this.ref;
  }
  // Fetch Wines List
  getList() {
    this.refs = this.db.list( this.path );
    return this.refs;
  }
  // Update Wine Object
  update(record: Wine) {
    this.ref = this.db.object( this.path + record.$key);
   // console.log("P inside", record);
    let item : Partial<Wine>  = {
      ...record
    }
    delete item?.$key;
    this.ref?.update(item);
  }
  // Delete Wine Object
  delete(id: string) {
    this.ref = this.db.object( this.path + id);
    this.ref.remove();
  }
}
